import { Divider, Grid2, Paper, Stack, Typography } from "@mui/material";
import { Reply } from "@mui/icons-material";
import useUIBp from "../../../../Hooks/useUIBoilerplate";
import OriginalMessage from "./Components/OriginalMessage";
import ReplyMessage from "./Components/ReplyMessage";

const UIText = {
  "es-CL": { replies: "Respuestas" },
  "en-US": { replies: "Replies" },
};

// A message rendered as a Teams-like card: the original message on top and,
// separated but inside the same box, the list of its replies (when any).
const MessageCard = (props) => {
  const { settings } = useUIBp();
  const t = UIText[settings.locale];
  const { replies } = props;
  const replyList = Array.isArray(replies) ? replies : [];

  return (
    <Grid2 container size={12} sx={{ marginBottom: 2 }}>
      <Paper variant="outlined" sx={{ width: "100%", padding: 2 }}>
        <OriginalMessage {...props} />
        {replyList.length ? (
          <>
            <Divider sx={{ marginY: 1.5 }} />
            <Grid2
              container
              {...{ size: 12, alignItems: "center", columnGap: 1 }}
            >
              <Reply color="primary" sx={{ fontSize: 18 }} />
              <Typography fontSize={14} sx={{ fontWeight: 600 }}>
                {t.replies}
              </Typography>
            </Grid2>
            <Stack spacing={1} sx={{ marginTop: 1 }}>
              {replyList.map((reply, idx) => (
                <ReplyMessage key={reply.id ?? idx} {...reply} />
              ))}
            </Stack>
          </>
        ) : null}
      </Paper>
    </Grid2>
  );
};

export default MessageCard;
